import PlannerMode from './Planner.mode';
import WorkerMode from './Worker.mode';

const AgentMode = {
    planner: PlannerMode,
    worker: WorkerMode,
};

export default AgentMode;
